// @ts-check
import React from "react"
import { TableFootCell } from "./TableFootCell.component"

/**
 * @param {import("./TableFoot.component.types").TableFootProps} props
 */
export const TableFoot = (props) => {
  const { table } = props

  return (
    <tfoot className="table__foot">
      {table.getFooterGroups().map((footerGroup) => (
        <tr key={footerGroup.id} className="table__foot-row">
          {footerGroup.headers.map((header) => (
            <TableFootCell key={header.id} header={header} />
          ))}
        </tr>
      ))}
    </tfoot>
  )
}
